export default __webpack_public_path__ + "static/media/maze.c3ef103b.png";